import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Calendar, MapPin, Trophy } from 'lucide-react';
import { apiService } from '../services/api';

const statusLabel = {
  draft: 'Draft',
  open_registration: 'Pendaftaran Dibuka',
  close_registration: 'Pendaftaran Ditutup',
  running: 'Sedang Berjalan',
  finished: 'Selesai',
};

const statusColor = {
  open_registration: 'bg-green-100 text-green-700',
  close_registration: 'bg-yellow-100 text-yellow-700',
  running: 'bg-blue-100 text-blue-700',
  finished: 'bg-gray-100 text-gray-700',
};

const Event = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const nextPath = searchParams.get('next');

  const buildEventTarget = (eventId) => {
    if (!nextPath) return `/event/${eventId}`;

    const [path, queryString = ''] = nextPath.split('?');
    const params = new URLSearchParams(queryString);
    params.set('eventId', eventId);
    const query = params.toString();
    return query ? `${path}?${query}` : path;
  };

  useEffect(() => {
    const loadEvents = async () => {
      try {
        const res = await apiService.getPublicEvents();
        setEvents(res.data || []);
      } catch (error) {
        console.error('Failed to load events', error);
      } finally {
        setLoading(false);
      }
    };

    loadEvents();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 py-8 sm:py-10">
      <div className="container mx-auto px-4">
        <div className="mb-6 sm:mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Event IJSL</h1>
          <p className="text-gray-600 mt-2">
            {nextPath
              ? 'Pilih event terlebih dahulu untuk melanjutkan ke halaman yang Anda tuju.'
              : 'Lihat detail event, kategori, dan peserta yang terdaftar.'}
          </p>
        </div>

        {loading ? (
          <div className="text-center py-12 text-gray-600">Loading event...</div>
        ) : events.length === 0 ? (
          <div className="bg-white rounded-lg shadow p-8 text-center text-gray-600">Belum ada event aktif.</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            {events.map((event) => (
              <Link
                to={buildEventTarget(event.id)}
                key={event.id}
                className="bg-white rounded-xl shadow hover:shadow-lg transition p-4 sm:p-5 border border-gray-100"
              >
                <div className="flex items-start justify-between gap-2 mb-3">
                  <h2 className="text-lg font-bold text-gray-900 line-clamp-2">{event.name}</h2>
                  <span className={`text-xs px-2.5 py-1 rounded-full font-medium ${statusColor[event.status] || 'bg-gray-100 text-gray-700'}`}>
                    {statusLabel[event.status] || event.status}
                  </span>
                </div>

                <p className="text-sm text-gray-600 line-clamp-2 mb-4">{event.description || '-'}</p>

                <div className="space-y-2 text-sm text-gray-700">
                  <div className="flex items-center gap-2">
                    <Trophy className="h-4 w-4" />
                    <span>{event.format === 'tournament_elimination' ? 'Tournament Eliminasi' : 'League Round Robin'}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <MapPin className="h-4 w-4" />
                    <span>{event.location || '-'}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Calendar className="h-4 w-4" />
                    <span>
                      {new Date(event.start_date).toLocaleDateString('id-ID')} - {new Date(event.end_date).toLocaleDateString('id-ID')}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Event;
